<template>
    <div class="box_content">
        <div class="news_container" v-if="list && list.length">
            <div class="news_item hvr-underline-from-center" v-for="(item, index) in list" :key="index" @click="showDetail( item )">
                <div class="img_box">
                    <img :src="item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1 " alt="">
                    <img :src="$ImgUrl + item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1 " alt="">
                    <img src="../../assets/static/index/left_nav_bg3.png" v-if="!item.news_headpic" alt="">
                </div>
                <div class="info_box">
                    <div class="news_title">
                        <span>{{ item.news_title }}</span>
                    </div>
                    <div class="news_content">
                        <span>{{ item.news_content }}</span>
                    </div>
                    <div class="time_box">
                        <span class="iconfont icon-shijian"></span> 时间: {{ item.create_time }}
                    </div>
                </div>
                <div class="icon_box">
                    <span class="el-icon-arrow-right"></span>
                </div>
            </div>
        </div>
        <div class="noMore" v-else>
            <img src="../../assets/static/index/nomore.png" alt="">
        </div>

        <div class="page_box" style="text-align:right;" v-if="list && list.length">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="page"
                :page-size="pageSize"
                @current-change="pageChange"
                :total="totalPage * pageSize">
                </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
                page: 1,
                pageSize: 10,
                totalPage: 1,
                cateName: "",
            }
        },
        computed: {
            cate_id() {
                return this.$route.query.cate_id  
            },
            isSearch () {
                return this.$route.query.isSearch 
            },
            keyword () {
        
                return this.$route.query.keyword 
            }
        },
        watch: {
            keyword () {
                this.getNewsList()
            }
        },
        mounted () {
            this.getNewsList();
        },
        methods: {
            // 获取新闻列表
            async getNewsList () {
                let { cate_id, isSearch, page, pageSize } = this 
                if ( isSearch == 0 ) {
                    let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id: Number(cate_id), page, pageSize, is_head: !cate_id? 1: '' })
                    if ( res.data.code == 1 ) {
                        this.list = res.data.res
                        this.cateName = res.data.cate_name
                        this.totalPage = res.data.totalPages
                        this.$emit("getname", this.cateName )
                    }
                } else {
                    let res = await this.$axios.post("/lencon/pc/index/news_search_list", { page: this.page, keywords: this.keyword })
                    if ( res.data.code == 1 ) {
                        this.list = res.data.res
                        this.totalPage = res.data.totalPages
                        this.$emit("getname", "新闻搜索")
                    }
                }
            },

            // 页码变化
            pageChange ( page ) {
                this.page = page 
                this.getNewsList()
            },

            // 查看详情
            showDetail ( item ) {
                this.$router.push({
                    path:`/NewsDetail/${item.news_id}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            }
        }
    }
</script>

<style>
.hvr-underline-from-center::before {
    background: #2767c4  !important;
}
</style>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.box_content {
    width: 1200px;
    min-height: 700px;
    background-color: #fff;
    margin: 40px auto;
    .cate_name {
        padding: 20px;
        font-size: 24px;
        font-weight: bold;
        color: #2767c4 ;
    }
    .news_item {
                width: 100%;
                display: flex;
                align-items: center;
                margin: 20px 0;
                padding: 20px;
                
                cursor: pointer;
                .img_box {
                    width: 265px;
                    height: 198px;
                    img {
                        width: 265px;
                        height: 198px;
                    }
                }
                .info_box {
                    margin-left: 20px;
                    flex:1;
                    .news_title {
                        // padding-top: 20px;
                        width: 770px;
                        font-size: 18px;
                        line-height: 40px;
                        @include SingleRow;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        span {
                            @include SingleRow;
                        }

                    }
                    .news_content {
                        font-size: 15px;
                        color: #7A7A7A;
                        height: 60px;
                        @include MultipleRows(4);
                        margin-top: 20px;
                    }
                    .time_box {
                        font-size: 14px;
                        color: #8E8E8E;
                        // line-height: 40px;
                    }
                }
                .icon_box {
                    width: 100px;
                    text-align: left;
                    padding-left: 20px;
                    span {
                        font-size: 30px;
                    }
                }
            }
}
</style>